import User from './user';
import Tickets from './tickets';
import Static from './static';
import Specialist from './specialist';

export { User, Specialist, Tickets, Static };
